export default __webpack_public_path__ + "static/media/dogb.c6c2e712.png";